if (import.meta.env.DEV) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const autoImport = import.meta.glob('./wdyr.ts', { eager: true });
  // nothing needs to be done with this variable but one needs to be declared in order to import the module
}
import { setup } from './setup';
import { renderApp } from './render-app';
setup().then(async () => {
  await renderApp();
});
